import { EventName, EventNames } from "./event_names";
import {
    AnalyticsUser,
    identifyMixpanelUser,
    initMixpanelClient,
    resetMixpanelUser,
    trackMixpanelEvent,
} from "./mixpanel_client";
import {
    identifyPosthogUser,
    initPosthogClient,
    resetPosthogUser,
    trackPosthogEvent,
} from "./posthog_client";
import {trackMarketingEvent} from "./marketing_tracking";
import {handleOnboardingAnalyticsEvent} from "../features/onboarding/onboarding_event_bridge";

// Keep this export name for backward compatibility with existing imports.
export const initMixpanel = () => {
    initMixpanelClient();
    initPosthogClient();
};

export const identifyUser = (user: AnalyticsUser) => {
    identifyMixpanelUser(user);
    identifyPosthogUser(user);
};

export const trackEvent = (
    name: EventName,
    properties: Record<string, any> = {}
) => {
    trackMixpanelEvent(name, properties);
    trackPosthogEvent(name, properties);
    trackMarketingEvent(name as EventNames);
    handleOnboardingAnalyticsEvent(name);
};

export const resetUser = () => {
    resetMixpanelUser();
    resetPosthogUser();
};

export * from "./event_names";
